<ion-breadcrumbs>
  <ion-breadcrumb
    *ngFor="let item of routes"
    [routerLink]="item.route"
    [routerLinkActiveOptions]="{
      exact: true
    }"
    routerLinkActive="router-active"
    >{{ item.title | titlecase }}</ion-breadcrumb
  >
</ion-breadcrumbs>
